module.exports = __webpack_public_path__ + "static/media/mSlider3.2f9c60c3.png";